<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row  :gutter="24">
          <a-card title="基础信息"> 
            <a-col :span="12">
              <a-form-model-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="name">
                <a-input v-model="model.name" placeholder="请输入姓名"  ></a-input>
              </a-form-model-item>
            </a-col>

            <a-col :span="12" v-if="codeVisible">
              <a-form-model-item label="身份证号" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="code">
                <a-input v-model="model.code" placeholder="请输入身份证号"  :disabled="code"></a-input>
              </a-form-model-item>
            </a-col>

            <a-col :span="12" v-if="!codeVisible">
              <a-form-model-item label="身份证号" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="fakeCode">
                <a-input value="******************" placeholder="请输入身份证号"  :disabled="code"></a-input>
              </a-form-model-item>
            </a-col>


            <a-col :span="12">
              <a-form-model-item label="手机" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="mobile">
                <a-input v-model="model.mobile" placeholder="请输入手机"  ></a-input>
              </a-form-model-item>
            </a-col>
          </a-card>
        </a-row>

        <a-row :gutter="24">
          <a-card title="接待人信息"> 
               <a-col :span="12">
                  <a-form-model-item label="接待人姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="receptionName">
                    <a-input v-model="model.receptionName" placeholder="请输入接待人姓名"  ></a-input>
                  </a-form-model-item>
              </a-col>

              <a-col :span="12">
                <a-form-model-item label="接待人工号" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="receptionCode">
                  <a-input v-model="model.receptionCode" placeholder="请输入接待人工号"  ></a-input>
                </a-form-model-item>
              </a-col>

              <a-col :span="12">
                <a-form-model-item label="接待人手机" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="receptionMobile">
                  <a-input v-model="model.receptionMobile" placeholder="请输入接待人手机"  ></a-input>
                </a-form-model-item>
              </a-col> 
          </a-card>
        </a-row>

        <a-row :gutter="24">
          <a-card title="拜访信息"> 
              <a-col :span="24">
                <a-form-model-item label="拜访法人" :labelCol="labelCol2" :wrapperCol="wrapperCol2" prop="corporation">
                  <a-input v-model="model.corporation" placeholder="请输入拜访法人"  ></a-input>
                </a-form-model-item>
              </a-col>

          <a-col :span="12">
              <a-form-model-item label="拜访事业群" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="businessGroupVal" >
                <a-select 
                  labelInValue 
                  allowClear
                  placeholder="请选择拜访事业群"
                  v-model="model.businessGroupVal"
                  :options="businessGroupOptions"
                  @change="handleGroupVal">
                </a-select>
              </a-form-model-item>
          </a-col>

          <a-col :span="12">
              <a-form-model-item label="拜访事业处" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="businessUnitVal">
                <a-select 
                  labelInValue 
                  allowClear
                  placeholder="请选择拜访事业处"
                  v-model="model.businessUnitVal"
                  :options="businessUnitOptions"
                  @change="handleUnitVal">
                </a-select>
              </a-form-model-item>
          </a-col>

          <!-- 厂区 区域 -->
            <a-col :span="12">
                <a-form-model-item label="访问厂区" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="factoryId">
                  <a-select 
                    allowClear
                    placeholder="请选择访问厂区"
                    v-model="model.factoryId"
                    :options="factoryOptions"
                    @change="factoryChange"
                    />
                </a-form-model-item>
            </a-col>

            <a-col :span="12">
                <a-form-model-item label="访问区域" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="areaId">
                  <a-select 
                    allowClear
                    placeholder="请选择访问区域"
                    v-model="model.areaId"
                    :options="areaOptions"
                    @change="areaChange"
                    />
                </a-form-model-item>
            </a-col>

            <a-col :span="12">
                <a-form-model-item label="停留楼栋" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="buildingId">
                  <a-select 
                    allowClear
                    placeholder="请选择停留楼栋"
                    v-model="model.buildingId"
                    :options="buildingOptions"
                    @change="buildingChange"
                    />
                </a-form-model-item>
            </a-col>


          <a-col :span="12">
            <a-form-model-item label="拜访时间" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="visitTime">
              <j-date placeholder="请选择拜访时间" v-model="model.visitTime" :show-time="true" date-format="YYYY-MM-DD HH:mm:ss"  style="width: 100%" />
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item label="离去时间" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="leaveTime">
              <j-date placeholder="请选择离去时间" v-model="model.leaveTime" :show-time="true" date-format="YYYY-MM-DD HH:mm:ss"  style="width: 100%" />
            </a-form-model-item>
          </a-col>
        
          </a-card>
        </a-row>

        <a-row :gutter="24">
          <a-card title="拜访人核酸信息"> 
            <a-col :span="12">
              <a-form-model-item label="核酸检测时间" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="detectionTime">
                <j-date placeholder="请选择核酸检测时间"  v-model="model.detectionTime" :show-time="true" date-format="YYYY-MM-DD HH:mm:ss" style="width: 100%" />
              </a-form-model-item>
            </a-col>
          
            <a-col :span="12">
              <a-form-model-item label="健康码状态" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="healthCode">
                  <j-dict-select-tag
                  type="list"
                  v-model="model.healthCode"
                  dictCode="pre_health_status"
                  placeholder="请选择健康码状态"
                  />
              </a-form-model-item>
            </a-col>

            <!-- 上传图片 -->
            <a-col :span="12">
              <a-form-model-item label="上传健康码截图" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="healthImage">
                <j-image-upload v-model="model.healthImage" bizPath="health" uploadSource="prevent"></j-image-upload>
              </a-form-model-item>
            </a-col>

          </a-card>
        </a-row>


      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction,postAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'VisitorForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      codeIsRead:{
        type: Boolean,
        required: true
      }

    },
    data () {
      return {
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        confirmLoading: false,
        validatorRules: {
           corporation: [
              { required: true, message: '请输入拜访法人!'},
           ],
           businessGroupVal: [
              { required: true, message: '请输入拜访事业群!'},
              { validator: this.checkBusinessGroupVal },
              
           ],
           businessUnitVal: [
              { required: true, message: '请输入拜访事业处!'},
              { validator: this.checkBusinessUnitVal },
           ],
           factoryId: [
                  { required: true, message: '请选择访问厂区'},
            ],
            areaId: [
                { required: true, message: '请选择访问区域'},
            ],
            buildingId: [
                { required: true, message: '请选择停留楼栋'},
            ],


           name: [
              { required: true, message: '请输入姓名!'},
           ],
           mobile: [
              { required: true, message: '请输入手机号码!'},
              { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码!'},
           ],
           code:[
              { required: true, message: '请输入身份证号'},
              { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入正确的身份证号'},
           ],

           receptionName: [
              { required: true, message: '请输入接待人姓名!'},
           ],
           receptionCode: [
              { required: true, message: '请输入接待人工号!'},
           ],
           receptionMobile: [
              { required: true, message: '请输入接待人手机号码!'},
              { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码!'},
           ],

           detectionTime: [
              { required: false, message: '请输入核酸检测时间'},
           ],
           visitTime: [
              { required: true, message: '请输入拜访时间!'},
           ],
           leaveTime: [
              { required: true, message: '请输入离去时间!'},
           ],
           healthCode: [
              { required: false, message: '请输入健康码状态!'},
           ],
        },
        url: {
          add: "/prevent/visitor/add",
          edit: "/prevent/visitor/edit",
          queryById: "/prevent/visitor/queryById/",
          queryBusinessGroupList: "/sys/sysDepart/queryBusinessGroupList",
          queryBusinessUnitList: "/sys/sysDepart/queryBusinessUnitList"
        },
        businessGroupOptions:[],
        businessUnitOptions:[],
        factoryOptions:[],
        areaOptions:[],
        buildingOptions:[],
        codeIsRead : false,
        codeVisible: true
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      code(){
        return this.codeIsRead
      }
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
      this.initBusinessGroupList();
      this.initFactoryOptions();
    },
    methods: {
       initBusinessGroupList(){
          getAction(this.url.queryBusinessGroupList,{applicationCode:'prevent'}).then(res=>{
            if(res.success){
              this.businessGroupOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.departName, value: item.id}
              return c;
            })
            }
          })
      },

      handleGroupVal(val){
          if(typeof val=='undefined'){
            this.businessUnitOptions=[];
            this.$set(this.model,'businessUnitVal',{})
            return;
          }
          
          // if(this.model.id){
             this.$set(this.model,'businessUnitVal',{})
          // }
          this.model.businessGroupId=val.key;
          this.model.businessGroupName=val.label;
          getAction(this.url.queryBusinessUnitList,{id:val.key}).then(res=>{
            if(res.success){
            this.businessUnitOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.departName, value: item.id}
              return c;
            })
            }
          })
      },
      handleUnitVal(val){
          if(typeof val=='undefined'){
            return;
          }
          this.model.businessUnitId=val.key;
          this.model.businessUnitName=val.label;
      },

      initFactoryOptions(){
        getAction('/prevent/factory/prefactorys',{pageNo:1,pageSize:100000}).then(res=>{
          if(res.success){
            this.factoryOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.name, value: item.id}
              return c;
            })
			    }
        })

      },

      factoryChange(val){
        if(typeof val=='undefined'){
          this.areaOptions=[];
          this.$set(this.model,'areaId',null)
          this.$set(this.model,'buildingId',null)
          return;
			   }
        //  this.$set(this.model,'areaId',null)
        //  this.$set(this.model,'buildingId',null)

         let factoryIds =[]
         factoryIds.push(val)
         postAction('/prevent/area/getAreaByFactoryId',factoryIds).then(res=>{
           if(res.success){
              this.areaOptions = res.result.map((item,index,arr)=>{
                let c = {label:item.name, value: item.id}
                return c;
              })
			      }
         })

      },

      areaChange(val){
        if(typeof val=='undefined'){
          this.buildingOptions=[];
          this.$set(this.model,'buildingId',null)
          return;
			   }
        //  this.$set(this.model,'buildingId',null)

         let areaIds =[]
         areaIds.push(val)
         postAction('/prevent/building/getBuildingByAreaId',areaIds).then(res=>{
           if(res.success){
              this.buildingOptions = res.result.map((item,index,arr)=>{
                let c = {label:item.name, value: item.id}
                return c;
              })
			      }
         })

      },

      buildingChange(val){
        if(typeof val=='undefined'){
			     return;
			  }
			  this.model.buildingId=val;
      },

      /**************************校验***********************************/
      checkBusinessGroupVal(rule, value, callback){
        if(!value.key){
          callback("请输入拜访事业群!")
        }else{
          callback()
        }
      },

      checkBusinessUnitVal(rule, value, callback){
          if(!value.key){
          callback("请输入拜访事业处!")
        }else{
          callback()
        }
      },


    /**************************框架***********************************/
      add () {
        // this.edit(this.modelDefault);
        this.codeIsRead = false
        this.codeVisible = true

        this.visible = true;
      },
      edit (record) {
        this.model = Object.assign({}, record);
        
        this.codeIsRead =true
        this.codeVisible = false

        //回显 事业群/事业处
        this.$set(this.model,'businessGroupVal',{key: this.model.businessGroupId,label: this.model.businessGroupName})
        this.handleGroupVal(this.model.businessGroupVal)
        this.$set(this.model,'businessUnitVal',{key: this.model.businessUnitId,label: this.model.businessUnitName})

        //回显 厂区 区域 楼栋
        this.factoryChange(this.model.factoryId)
        this.areaChange(this.model.areaId)
        
        this.visible = true;
      },
      
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>